// import $ from 'jquery';
import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

// MOVE TO LIBS-HEAD.js
// import 'jquery-clickout';

//---------- TOUCH EVENTS --------------------------------------//
import '@benmajor/jquery-touch-events';

export default class{ // export class Layout
    
    constructor(options) {

    	// OPTIONS
        this.defaults = {
        	main: undefined,
        	skip_intro: false
        }

        this.options = {};
		Object.assign(this.options, this.defaults, options);
        this.namespace 	= 'layout';

		this.main 		= this.options.main;

        // VARS
		this.$window 	= $(window);
		this.$doc 		= $(document);
		this.$html 		= $('html');
		this.$body 		= $('body');

		this.colors 		= this.$body.attr( 'data-colors' ).split( ',' );
		this.class_colors 	= this.$body.attr( 'data-class' ).split( ',' );


		this.init()

    }

 	init() {
 		
		this.initMainMenu();

		// this.initSearch();

		// this.paintMenu( document.location.href );

		this.initMobile();

		this.debounceResize(true);

		//this.addEvents( true, true );
		
		setTimeout( ()=>{
			this.onResize();
			// this.checkHash();
			// this.checkBack();
		}, 200 );


		this.initMouseOverHeader( true );
		this.initMenuLanguages();

		this.initOnNewPage( true );

		this.initCookieConsent();

    }

    initOnNewPage( firstTime ){

    	this.adjustColorElemnt();

		// this follow the main page color
		this.changeColor( $( '.change-color' ) );
		// this are independent
		this.changeIndependentColor( $( '.set-color' ) );

		this.initLiveSearch();

		this.paintMenu();

		this.changeLogo();

		if ( !firstTime ){
			this.ajaxifyForms();
			
		}
    }

    initMouseOverHeader( b ){
		const $header = $( '#desktop-header' );
    	if ( b ){

			$header.on( 'mouseenter', ()=>{this.$html.addClass( 'mouseover-header' );this.$body.removeClass('hide-desktop-nav')} );
			$header.on( 'mouseleave', ()=>this.$html.removeClass( 'mouseover-header' ) );

    	}
    	else{

			$header.off( 'mouseenter', ()=>{this.$html.addClass( 'mouseover-header' );this.$body.removeClass('hide-desktop-nav')} );
			$header.off( 'mouseleave', ()=>this.$html.removeClass( 'mouseover-header' ) );

    	}
    }

    changeLogo(){

    	//console.log( 'changeLogo' );
    	let i = parseInt( $('.logo-container').attr( 'data-num-forms' ) ),
    		r = 1 + Math.floor(Math.random()*(i-1)),
    		_class = 'form_' + r;

    		// logo principal always for homepage
    		if ( this.$body.hasClass( 'home' ) ){
    			_class = 'form_1';
    		}

    		// remove class active
    		$('.logo-container .cnt').removeClass( 'active' );

    		// set new random found active
    		$('.logo-container .' + _class ).addClass( 'active' );
    	;
    }


	changeColor( $els ){

		if ( $els.length <= 0 ) return;

		let color, color_class, $el, r;

		color 			= $( '#main' ).attr( 'data-color' );
		color_class 	= $( '#main' ).attr( 'data-class' );

		if ( color === 'random' ){
			r 				=   Math.floor(Math.random() * this.colors.length);
			color 			= 	this.colors[ r ];
			color_class 	=	this.class_colors[ r ];
		}

		// add color class to the body, so we always now which scheme to apply to the header
		this.$body.addClass( color_class );
		this.$body.attr( 'data-changed-color', color );
		this.$body.attr( 'data-changed-color-class', color_class);

		// change the bar safari
		$('meta[name="theme-color"]').attr( 'content', color );


		$els.each( (i,el)=>{
			
			$el = $(el);

			

			if ( color ){
				

				gsap.set( $el, { 'background-color' : color } );
				
				// body color
				// gsap.set( this.$body, { 'background-color' : color } );

				// write that color as reference attr on body
				// this.$body.attr( 'data-chose-color', color );

				// desktop header
				// gsap.set( $( '.desktop-menu-container .int' ), { 'background-color' : this.convertHexToRGBA( color, 0.9 ) } );
				
				// mobile panel
				// gsap.set( $( '#mobile-panel' ), { 'background-color' : color } );

				// play button color
				// gsap.set( $( '.play-button-color' ), { 'background-color' : color } );





			}

		} );
		
	}

	adjustColorElemnt(){
		$('blockquote').addClass( 'set-color' );
	}

	changeIndependentColor( $els ){

		if ( $els.length <= 0 ) return;

		let color, color_class, $el, r, $line;

		$els.each( (i,el)=>{
			
			$el = $(el);

			color 			= $el.attr( 'data-color' )?$el.attr( 'data-color' ):'';
			color_class 	= $el.attr( 'data-class' )?$el.attr( 'data-class' ):'';
			if ( color === 'random' ){
				r 				=   Math.floor(Math.random() * this.colors.length);
				color 			= 	this.colors[ r ];
				color_class 	=	this.class_colors[ r ];
			}

			// default to page color if not found
			if ( color === '' ){
				color 			= 	this.$body.attr( 'data-changed-color' );
				color_class 	=	this.$body.attr( 'data-changed-color-class' );				
			}

			if ( color ){

				// blockquote
				if ( $el.is( 'blockquote' ) ){
					$el.css('--quote_color', color );
				}
				else{

					gsap.set( $el, { 'background-color' : color } );
					$el.addClass( color_class );

					// Set also the line under the link for mobile for module-grid
					if ( $el.hasClass( 'module-header' ) ){
						$line = $el.parents( '.module-grid' ).find( '.line-color' );
						if ( $line.length >  0 ){
							gsap.set( $line, { 'background-color' : color } );
							$line.addClass( color_class );
						}
					}

				}

			}

			if ($el.hasClass('set-color-only-once')){
				$el.removeClass( 'set-color' ).removeClass( 'set-color-only-once' );
			}

		} );
		
	}


	setElementColorToPageColor( $els ){

	}

	convertHexToRGBA(hexCode, opacity = 1){  
	    let hex = hexCode.replace('#', '');
	    
	    if (hex.length === 3) {
	        hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
	    }    
	    
	    const r = parseInt(hex.substring(0, 2), 16);
	    const g = parseInt(hex.substring(2, 4), 16);
	    const b = parseInt(hex.substring(4, 6), 16);
	    
	    /* Backward compatibility for whole number based opacity values. */
	    if (opacity > 1 && opacity <= 100) {
	        opacity = opacity / 100;   
	    }

	    return `rgba(${r},${g},${b},${opacity})`;
	}


    // -----------------------------------------------------------------[ RESIZE HANDLER ]--------------------------------------------------------------//
    debounceResize(b){
      if ( b ){
        // debounce resize
        this._debResize = _debounce( () => this.onResize(true), 17 );
        this.$window.on( 'resize', this._debResize );
		// Listen for orientation changes
		window.addEventListener("orientationchange", ()=> this.onOrientationChange(), false);
      }
      else{
        if ( this._debResize ){
          this._debResize.cancel();
          this.$window.off( 'resize', this._debResize );
        }        
		// Listen for orientation changes
		window.removeEventListener("orientationchange", ()=> this.onOrientationChange(), false);
      }
    }

    onOrientationChange(){
    	//console.log( 'onOrientationChange');
    	setTimeout( ()=>this.onResize(true), 77 );
    }

	onResize(b){

		let w = this.$window.width(), h = this.$window.height(), mobileAvailheight  = window.innerHeight, $s, $m;

		// this class is used for layouts that need to be resized before revealed. For example .home-MAIN-promo (opacity=0 and resized opacity 1)
		this.$body.addClass( 'resized' );




		return;

		if ( ! this.$html.hasClass( 'scroll-smooth' ) ){

			$m = $('.alert-bar');

			$('#smooth-scroll').css({
				'margin-bottom' : $('footer.footer.no-smooth').outerHeight() + ($m.length>0?$m.height():0) - 1
			})			
		}
		else{

			$('#smooth-scroll').css({
				'margin-bottom' : '0px'
			})			

		}


		//return;
		
		/*
		$s = $('.layout-sidebar.main-content');
		if ( $s.length > 0 ){
			$s.css('height','auto');


			console.log( 'qui' );

			if ( w >= 1024 ){
				$s.height( $('#main').height() - $('#escr-hero').height() );
			}

		}
		*/

		/*
		// mobile panel
		$s = $('#mobile-panel');
		$s.height( mobileAvailheight );
		// mobile panel scroll content
		$m = $s.find( '.panel-container' );
		$m.height( $s.height() -  80 - $s.find( '.footer' ).outerHeight() );
		*/

	}
	
	initMainMenu(){
		this.initLayoutDesktopMenu();
		this.initDesktopMenuHover();
		this.initSearch();
		this.initPanelMenu();
	}

	clearAllMenuSelections(){
	}

	openDesktopMenu(b){
	}

	activateClickOut(b){
	}

	

	initLayoutDesktopMenu(){
		let $menu = $('#menu-full-desktop');
		$menu.find( '> li' ).addClass( 'item-grid' );
		$menu.append( '<li class="gutter-sizer"></li>' );
		$menu.addClass( 'grid-packery' );
		this.main.WIDGETS.initPackeryGrids( true, $('#menu-panel'));


		setTimeout( ()=>this.onResize(true), 37 );
	}


	initDesktopMenuHover(){
		$('#desktop-header').on( 'mouseenter', (e)=>{
			this.activateMenu( e, true );
		});
		$('#desktop-header').on( 'mouseleave', (e)=>{
			this.activateMenu( e, false );
		});
		this.$body.on( 'mousemove', (e)=>{
			if ( !this.$html.hasClass( 'state-menu-hover' ) && e.clientY <= 100 ){
				this.activateMenu( e, true );
			}
			if ( this.$html.hasClass( 'state-menu-hover' ) && e.clientY > 100 ) { 
				this.activateMenu( e, false );
			}
		})
	}

	activateMenu( e, b ){
		clearTimeout( this.timeout_autohide );
		if ( b ){
			this.$html.addClass( 'state-menu-hover' );
		}
		else{
			this.timeout_autohide = setTimeout(()=>{
				this.$html.removeClass( 'state-menu-hover' );
			}, 400 )
		}
	}
	
	initSearch(){
		let $form = $('.module-search-form form'), $input, $module, $live_search;

		$form.on( 'submit', (e)=>{

			$module = $(e.currentTarget).parent();
			$input = $(e.currentTarget).find( '.search-field' );


			if ( $input.val() === '' ){
				e.preventDefault();
			}

			if ( $module.hasClass( 'open-close' ) ){
				if ( ! $module.hasClass( 'open' ) ){
					
					e.preventDefault();

					this.openSearch( $module, true );

					$module.on(  'clickout', ()=> this.openSearch( $module, false ) );

				}
				else{
					if ( $input.val() === '' ){

						this.openSearch( $module, false );

					}
				}
			}

		});	

	}

	initLiveSearch(){
		let $live_search = $('.rlvlive');

		if ( $live_search.length > 0  ){

			$live_search.on( 'mouseenter', ()=>{

				if ( this.main.smoother ){
					this.main.smoother.paused( true );
				}
			
			})
			$live_search.on( 'mouseleave', ()=>{

				if ( this.main.smoother ){
					this.main.smoother.paused( false );
				}
				
			})
		}

		if ( this.main.options.is_ajax ){
			$('input[data-rlvlive="true"]').relevanssi_live_search();
		}
	}

	ajaxifyForms(){
		const $form = $('.wpcf7-form');
		if ( $form.length > 0 ){
			wpcf7.init( $form[0] );
		}
	}

	openSearch( $module, b ){

		if ( b ){

			let $input = $module.find( '.search-field' );
			$module.addClass( 'open' );
			$('#main_menu_desktop').addClass( 'open-search' );
			$input.val('');
			$input.focus();
		}
		else{

			$module.off(  'clickout', ()=> this.openSearch( $module, false ) );
			$module.removeClass( 'open' );
			$('#main_menu_desktop').removeClass( 'open-search' );

		}

	}

	initPanelMenu(){
		let $open = $('.burger'), $close = $( '.burger-close' ), $input = $('.module-search-form .search-field'), $scroll = $('#menu-panel .scroll-content');
		$open.on( 'click', (e)=>{
			e.preventDefault();
			$input.val( '' );
			this.openPanelMenu( true );
			disableBodyScroll( $scroll[0] );
			if ( this.main.smoother ){
				this.main.smoother.paused( true );
			}
			
		});
		$close.on( 'click', (e)=>{
			e.preventDefault();
			enableBodyScroll( $scroll[0] );
			if ( this.main.smoother ){
				this.main.smoother.paused( false );
			}
			this.openPanelMenu( false );
		});
	}

	openPanelMenu( b ){
		if ( b ){
			this.$body.addClass( 'menu-panel-open' );
			this.__reSetScrollPosition(false);
		}
		else{
			this.$body.removeClass( 'menu-panel-open' );
			this.__reSetScrollPosition(true);
			this.resetMobileMenu();
		}
	}


	__reSetScrollPosition( b ){
		let y = 0;
		if ( b ){
			y = this.scrollPos;
		}
		else{
			if ( this.main.smoother ){
				this.scrollPos = this.main.smoother.scrollTop();
			}
			else{
				this.scrollPos = this.$window.scrollTop();
			}
		}
		if(  y === undefined ){
			return;
		}

		if ( this.main.smoother ){
			this.main.smoother.scrollTo( y, false ); // instant
		}
		else{
			gsap.to(this.$window, {duration: 0, scrollTo: y});
		}
	}

	paintMenu(){

		//return;

		// menu loaded trough barba
		let $p = $('#paint_menu'), 
		// main navigation (header + nav compact )
		$main_navs = $('#main_menu_desktop'), //,'#menu-secondary-menu','#menu-footer-menu'],
		$ul, $li,
		found = false;

		$main_navs.each( (j,ul)=>{

			$ul = $(ul);

			// clear if not was found any relation --> unselected: all on!
			$ul.removeClass( 'all-unselected' );

			// clear
			$ul.find( '> li' ).removeClass( 'current-menu-item' ).removeClass( 'current-menu-parent' ).removeClass( 'current-menu-ancestor' );

			// set selecction
			$ul.find( '> li' ).each( (i,el) => {

				if ( !found ){
					$li = $(el);
					// check
					if ( 		$p.find( 'li' ).eq(i).hasClass( 'current-menu-item' ) 
							|| 	$p.find( 'li' ).eq(i).hasClass( 'current-menu-parent' ) 
							|| 	$p.find( 'li' ).eq(i).hasClass( 'current-menu-ancestor' )
							|| 	$p.find( 'li' ).eq(i).hasClass( 'current-page-parent' ) 
							|| 	$p.find( 'li' ).eq(i).hasClass( 'current-page-ancestor' )

					){
						$li.addClass( 'current-menu-item' );
						found = true;
					}
				}
			} );

		} );

		if ( !found ){
			this.paintMenuTemplate();
		}
	}	

	paintMenuTemplate(){

		if ( this.$body.hasClass( 'tax-issue' ) ){
			return this.setMenuSelection( 'issues' );
		}

		if ( this.$body.hasClass( 'single-team' ) || this.$body.hasClass( 'tax-team_type' ) ){
			return this.setMenuSelection( 'about' );
		}

		if ( this.$body.hasClass( 'single-member' ) || this.$body.hasClass( 'tax-country' ) || this.$body.hasClass( 'tax-member_type' ) ){
			return this.setMenuSelection( 'members' );
		}

		if ( this.$body.hasClass( 'tax-working-group' ) || this.$body.hasClass( 'tax-initiative' ) ){
			return this.setMenuSelection( 'working-group' );
		}

		if ( this.$body.hasClass( 'single-resource' ) || this.$body.hasClass( 'tax-resource-category' ) || this.$body.hasClass( 'tax-resource-type' )  || this.$body.hasClass( 'tax-thematic_focus' ) || this.$body.hasClass( 'single-case_law' ) ){
			return this.setMenuSelection( 'resources' );
		}

		if ( this.$body.hasClass( 'single-post' ) || this.$body.hasClass( 'tax-news_type' ) ){
			return this.setMenuSelection( 'latest' );
		}

		this.setMenuUnselected();
	}

	setMenuSelection(  which ){

		//console.log( which );
		let i = -1;
		switch( which ){ 
			case 'issues':
				i = 0;
			break;   
			case 'about':
				i = 1;
			break;   
			case 'members':
				i = 2;
			break;   
			case 'working-group':
				i = 3;
			break;   
			case 'resources':
				i = 4;
			break;   
			case 'latest':
				i = 5;
			break;   
		}
		if ( i !== -1 ){
			let $main_navs = $('#main_menu_desktop'), $ul, $li;

			$main_navs.each( (j,ul)=>{
				$ul = $(ul);
				$ul.find( 'li' ).each( (z,el) => {
					$li = $(el);
					// clear
					$li.removeClass( 'current-menu-item' ).removeClass( 'current-menu-parent' ).removeClass( 'current-menu-ancestor' );

					if ( z === i ){
						$li.addClass( 'current-menu-item' );
					}
				} );
			} );

		}
	}

	setMenuUnselected(){
		let $main_navs = $('#main_menu_desktop');
		$main_navs.addClass( 'all-unselected' );
	}

/*
	paintMenu( url ){
		let menus = [$('#menu-main-menu'), $('#menu-main-menu-1'), $('#menu-footer-menu')], i, $mnu, $li, found,
			current 		= 'current-menu-item',
			unselected  	= 'state-all-unselected';

		for( i=0; i<menus.length; i++ ){
			$mnu = menus[i];
			$li = $mnu.find( 'li' );
			found = false;

			// reset
			$li.removeClass( current ).removeClass( unselected );
			// find which one if selected
			$li.each( function(){
				if ( $(this).find( 'a' ).attr( 'href' ) === url ){
					$(this).addClass( current );
					found = true;
				}
			});
			// if there is no selection -> unselected ( only for main menu's )
			if ( !found && i < 2 ){
				$li.addClass( unselected );
			}
		}

		// special cases ( mostly single templates, taxonomies and categories, sub-pages )
		// portfolio
		if ( this.$body.hasClass( 'single-project' ) || this.$body.hasClass( 'page-template-portfolio' ) || this.$body.hasClass( 'tax-project_category' ) ){
			this.setMenuSelection( 0, current, unselected );
		}
		// profile
		else if ( this.$body.hasClass( 'parent-pageid-9' ) || this.$body.hasClass( 'single-people' ) ){
			this.setMenuSelection( 2, current, unselected );
		}
		// news
		else if ( this.$body.hasClass( 'single' ) || this.$body.hasClass( 'page-template-news' ) || this.$body.hasClass( 'category' ) ){
			this.setMenuSelection( 3, current, unselected );
		}

	}

	setMenuSelection( index, current, unselected ){
		let menus = [$('#menu-main-menu'), $('#menu-main-menu-1')], $mnu, $li, i;
		for( i=0; i<menus.length; i++ ){
			$mnu = menus[i];
			$li = $mnu.find( 'li' );
			// reset
			$li.removeClass( unselected );
			// set
			$mnu.find( 'li:eq(' + index + ')' ).addClass( current );
		}		
	}	
*/


	//----------------------------------------------------------- MOBILE ---------------------------------------//

	initMobile(){
		let $li, $a, $submenu, $menu = $( '#menu-full-mobile' );

		//$('#mobile-header .header-mobile .burger').on( 'tap', 		()=>this.openDrawerMobile(true) );
		//$('#mobile-panel .header-mobile .close').on( 'tap', 		()=>this.openDrawerMobile(false) );

		// submenus -- slideToggle, Open/Close
		$menu.find( 'li.menu-item-has-children' ).each( (i,el) =>{
			$li = $(el);

			// add itself to the first item of the submenu
			$submenu = $li.find('.sub-menu');
			$submenu.prepend( $li.clone() );


			$li.find( '> a' ).addClass( 'no-barba' ).on( 'click', (e)=>{
				e.preventDefault();
				e.stopImmediatePropagation();

				$a = $(e.currentTarget);
				this.toggleSubmenuMobile( $a );
			});

			// init --> close submenu
			$a = $li.find( '> a' );
			$a.data( 'open', true )
			this.openSubmenuMobile( $a, false );
			
		});

		// this.initMobileSearch();
	}

	/*
	toggleDrawerMobile(){
		this.openDrawerMobile( ! this.$body.hasClass( 'menu-mobile-open') );
	}
	
	openDrawerMobile( b ){
		let $scroll = $('#mobile-panel .panel-container');
		if ( b ){
			if ( !this.$body.hasClass( 'menu-mobile-open') ){
				this.$body.addClass( 'menu-mobile-open' );
				disableBodyScroll( $scroll[0] );
			}
		}
		else{
			if ( this.$body.hasClass( 'menu-mobile-open') ){
				this.$body.removeClass( 'menu-mobile-open' );
				enableBodyScroll( $scroll[0] );
				setTimeout( () => this.resetMobileMenu(), 300 );
			}
		}
	}
	
	initMobileSearch(){
		let $s = $('#drawer-mobile .search'), $input = $('#drawer-mobile .searchfield');
		$s.on( 'click', ()=>{
			$('#drawer-mobile').addClass( 'activate-search' );
			$input.focus();
		});
		$input.on( 'blur', ()=>{
			$('#drawer-mobile').removeClass( 'activate-search' );
		})
	}
	*/

	toggleSubmenuMobile( $a ){
		this.openSubmenuMobile( $a, !$a.data( 'open' ) );
	}

	openSubmenuMobile( $a, b ){
		let $submenu = $a.parents('li').find('.sub-menu');
		if ( b && $a.data( 'open' ) ){
			return;
		}
		if ( b ){
			$submenu.slideDown();
			$a.parents('li').addClass( 'open' );
		}
		else{
			$submenu.slideUp();
			$a.parents('li').removeClass( 'open' );
		}
		$a.data( 'open', b );
	}

	resetMobileMenu(){
		let $li, $a;
		$('#menu-full-mobile > li').each((i,el)=>{
			$li = $(el);
			if ( $li.hasClass( 'menu-item-has-children' ) ){
				$a = $li.find( '> a' );
				this.openSubmenuMobile( $a, false );
			}
		});
		$('#menu-panel .scroll-content').scrollTop(0);	
	}

	


	checkBack(){
		let $a = $('.artwork-detail .history-back'), $back, prev;
		if ( $a.length > 0 ){

			// if we are entereing directly to the page (ie, artwork page) the back button will be invisible
			prev = this.main.barba_history_previous();
			if( ! prev ){
				$back = $a.parents( '.back' );
				if ( $back.length > 0 ){
					$back.css({
						display: 'none'
					})					
				}
			}
			else{ // otherwise, when click, we go back to history ...
				$a.on( 'click', (e)=>{
					e.preventDefault();
					prev = this.main.barba_history_previous();
					if ( prev ){
						this.main.barba_triggerURL( prev.url, $(e.currentTarget) );
					}
				})				
			}
		}
	}
	
 	checkHash(){
 		let hash = document.location.hash, $a, $el, href, url;


 		// on page load, if the url has an hash it will try to find an element with the hash ID and scroll to it.
 		if ( hash ){
 			// anchors (https://mspc.local/support/other-ways-to-give/#park-dedications)
 			$a = $( hash );
 			if ( $a.length > 0 ){
 				//console.log( 'hash on load' )
 				this.scrollToHash( $a );
 			}
 			// menus
 			/*
 			hash = hash.substring(1).replace( /-/g , ' ');
 			$a = $('#' + hash );
 			if ( $a.length > 0 ){
 				if ( $a.attr( 'name') === hash ){
 					this.scrollToHash( $a );
 				}
 			} 
 			*/
 		}


 	}

 	addEvents(b, firstTime){

 		if ( b ){

 			//$( 'a' ).each( (i,el)=>{this.onFetchHash(el,true)} );

	 		// check urls with hashes from menus ( Paractice/About for example)
	 		$('a.menu-anchor').on( 'click', (e)=>{this.onClickMenuAnchor(e)} );
	 		$('main a').on( 'click', (e)=>{this.checkHashLinks(e)} );

	 		// only once for the footer
	 		if ( firstTime ){
	 			$('#menu-footer-menu a').on( 'click', (e)=>{this.checkHashLinks(e)} );
	 		}

 		}
 		else{

 			//$( 'a' ).each( (i,el)=>{this.onFetchHash(el,false)} );

	 		$('a.menu-anchor').off( 'click', (e) =>{this.onClickMenuAnchor(e)} );
	 		$('main a').off( 'click', (e)=>{this.checkHashLinks(e)} );

 		}
 	}

 	onClickMenuAnchor(e){
 		let hash, $a, $el, href;
		$a = $(e.currentTarget);
		href = $a.attr( 'href' );
		hash = href.substring(1).replace( /-/g , ' ');
		$el = $( href );
		if ( $el.length > 0 ){
			e.preventDefault();

			// the offset is already defined in the html !!!

			//this.scrollToHash( $el, $a.attr( 'data-offset' )? parseInt($a.attr( 'data-offset' )) : false, 0.01 );
			this.scrollToHash( $el, 0.1, 0.01 );
			// document.location.hash = href.substring(1).replace( /-/g , ' ')
			// history.replaceState(null, null, document.location.pathname + '#' + hash );
		}
 	}

 	checkHashLinks(e){
 		let hash, $a, $el, href, c;
		$a = $(e.currentTarget);
		href = $a.attr( 'href' );

        if ( href == '#' ) {
            return true;
        }

		if ( href.indexOf( '#' ) !== -1 ){
			c = href.split( '#' );
			hash = c[1];
		}
		$el = $( '#' + hash );

		// heck if element #hash exist and the link belong to  same page
		if ( $el.length > 0 && document.location.href.indexOf(c[0]) !== -1  ){
			e.preventDefault();

			// the offset is already defined in the html !!!

			//this.scrollToHash( $el, $a.attr( 'data-offset' )? parseInt($a.attr( 'data-offset' )) : false, 0.01 );
			this.scrollToHash( $el, 0.1, 0.01 );
			// document.location.hash = href.substring(1).replace( /-/g , ' ')
			// history.replaceState(null, null, document.location.pathname + '#' + hash );
		}
  	}


 	scrollToHash( $el, offset, delay ){
 		gsap.to( $(window), {duration: 0.8, scrollTo: { y : $el[0], offsetY: offset?offset:0 }, delay: delay?delay:0.4, ease: 'power.easeOut' });
 	}


 	initMenuLanguages(){
 		$('.menu-languages').find('a').addClass( 'no-barba' );
 	}
 	updateLanguageMenu( html ){
 		let $mnu = $(html).find( '.menu-languages' );
 		$('.menu-languages').each((i,el)=>{
 			$(el).html( $($mnu[i]).html() );
 		});
 		this.initMenuLanguages();
 	}


 	//----------------------------------------[  COOKIE CONSENT ]--------------------------------------------------//
 	initCookieConsent(){
 		let $link = $( 'button[data-cc="c-settings"]' );
 		if (  $link.length > 0 ){
 			$link.on( 'click', ()=>{
 				this.checkForModalClose( true );
 			});
 		}
 	}

 	checkForModalClose( b ){
 		if ( b ){
			this.modalObserver = new MutationObserver( ( mutationList, observer ) => { this.callbackModal( mutationList, observer ) } );
			this.modalObserver.observe( this.$html[0] , { attributes: true } );

			// when the modal is open
			if ( this.main.smoother ){
				this.main.smoother.paused( true );
			}

 		}
 		else{
 			this.modalObserver.disconnect();

 			// when the modal is close
			if ( this.main.smoother ){
				this.main.smoother.paused( false );
			}

 		}
 	}

 	callbackModal( mutationList, observer ){
	  mutationList.forEach((mutation) => {
	    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
	      	// handle class change
	    	if( ! this.$html.hasClass( 'show--settings' ) ){

	    		this.checkForModalClose( false );
	    	}
	    }
	  })

 	}




	onBarbaChangeState( state, data ){

		

		switch ( state ){
			case 'before':
				this.addEvents( false );
				this.openPanelMenu( false );

				if ( this.main.smoother ){
					this.main.smoother.paused( true );
				}
				
				break;
			case 'beforeEnter':
				// this.paintMenu( data.next.url.href );
				this.onResize();
				//this.checkFooter();

				this.updateLanguageMenu( data.next.html );
				this.addEvents( true );
				this.initOnNewPage( false );
				break;
			case  'after':
				//this.checkHash();
				//this.checkBack();

				if ( this.main.smoother ){
					this.main.smoother.paused( false );
				}

				break;
		}
	}

	onOnceReady(){
		//this.checkFooter();
	}

	checkFooter(){
		/*
		if ( this.main.options.scrollSmooth ){
			if ( this.$body.hasClass( 'home' ) ){
				this.$body.append( $( '#footer' ) );
			}
			else{
				$('#smooth-content').append( $('#footer') );
			}					
		}
		*/
	}

}

